module.exports = __webpack_public_path__ + "static/register-background.jpg";